export class Recorder {
    private stream: MediaStream | undefined;

    getStream(): MediaStream | undefined {
        return this.stream;
    }

    async createNewStream(): Promise<void> {
        this.stream = await window.navigator.mediaDevices.getUserMedia({ audio: true, video: false });
    }

    firstSupportedMediaType(): string | undefined {
        return ["audio/mp4", "audio/webm"].find((contentType) => MediaRecorder?.isTypeSupported(contentType));
    }

    destroyStream(): void {
        this.stream?.getTracks().forEach((track) => track.stop());
        this.stream = undefined;
    }
}
